/* ==========================================================================
   Naar Halı — "Hediyeni Kazan" sekmesinin kapatma düğmesi (16 Eki 2026)

   Pushouse uygulaması sekmenin yanına bir kapatma (×) düğmesi koyuyor
   (`.pshs-reopen-close`, "Hide wheel launcher") ama tıklayınca hiçbir şey olmuyor: uygulamanın
   betiğinde bu düğmeyi dinleyen kod yok, ayrıca sekme satır içi `display:block !important`
   ile zorla görünür tutuluyor. Düğme görünür yapılınca "çalışmıyor" dendi.

   Çözüm: düğmeye tıklanınca tarayıcıya "kapattı" damgası vurulur (7 gün) ve <html>'e
   `naar-cark-kapali` sınıfı eklenir; sekmeyi ekran dışına iten kural assets/naar-duzeltmeler.css
   içinde (satır içi !important `display`ı geçmenin tek yolu `translate`). Çark pencerelerinin
   kendisine ve uygulamanın başka hiçbir davranışına dokunulmaz.
   ========================================================================== */
(function () {
  var ANAHTAR = 'naar-cark-kapali';
  var SURE_MS = 7 * 24 * 60 * 60 * 1000;

  function kapaliMi() {
    try {
      var t = parseInt(localStorage.getItem(ANAHTAR) || '0', 10);
      return !!t && Date.now() - t < SURE_MS;
    } catch (e) {
      return false;
    }
  }
  function uygula() {
    document.documentElement.classList.toggle('naar-cark-kapali', kapaliMi());
  }
  uygula();

  document.addEventListener(
    'click',
    function (olay) {
      var dugme = olay.target.closest && olay.target.closest('.pshs-reopen-close');
      if (!dugme) return;
      olay.preventDefault();
      olay.stopPropagation(); // uygulamanın sekmeyi açan dinleyicileri tetiklenmesin
      try {
        localStorage.setItem(ANAHTAR, String(Date.now()));
      } catch (e) {}
      uygula();
    },
    true
  );
})();
